var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClientsIm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#fff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2406 5110 c-251 -40 -509 -184 -660 -369 -117 -143 -194 -301 -231 -477 -21 -98 -24 -293 -6 -394 52 -290 222 -547 468 -707 130 -85 264 -138 412 -163 26 -4 -114 -8 -329 -9 -206 -1 -404 -6 -440 -11 -154 -25 -292 -98 -390 -208 -61 -68 -134 -213 -150 -297 -8 -42 -10 -337 -8 -986 l3 -925 25 -37 c14 -21 43 -50 64 -65 l39 -27 691 -3 691 -2 -42 37 c-93 84 -216 247 -273 362 -136 274 -102 662 81 932 234 347 622 469 1043 328 50 -16 122 -47 161 -67 l71 -38 75 38 c65 34 245 97 322 113 l27 5 0 148 c0 171 -12 229 -70 347 -89 181 -255 304 -460 341 -53 9 -186 14 -455 15 -266 1 -364 4 -325 10 219 37 449 162 600 326 392 428 378 1078 -32 1484 -134 133 -302 228 -486 275 -109 28 -313 40 -416 24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2975 1931 c-190 -31 -341 -129 -445 -288 -140 -213 -170 -494 -76 -706 58 -132 212 -307 406 -464 206 -166 671 -456 753 -470 38 -6 73 10 247 110 270 154 544 354 705 512 210 207 285 362 285 586 0 162 -40 300 -124 428 -174 267 -464 359 -791 250 -82 -28 -206 -89 -279 -138 l-29 -19 -55 36 c-189 120 -437 188 -597 163z m1380 -460 c104 -47 153 -174 106 -276 -71 -158 -296 -167 -380 -15 -60 108 -8 252 109 299 40 16 122 12 165 -8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientsIm);
export default __webpack_public_path__ + "static/media/clients-im.d9af656ee50021854aa8286da9126860.svg";
export { ForwardRef as ReactComponent };